export function openAffiliateLink(
  url?: string,
  options: { couponId?: string } = {},
): boolean {
  if (!url || typeof window === "undefined") return false;

  const returnUrl = new URL(window.location.href);
  if (options.couponId) {
    returnUrl.searchParams.set("couponId", options.couponId);
  }

  const couponTab = window.open(returnUrl.toString(), "_blank");
  if (couponTab) {
    couponTab.opener = null;
  }

  window.location.assign(url);
  return true;
}
